import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetStartedFixedComponent } from './get-started-fixed.component';
import { GetStartedFormModule } from '../get-started-form/get-started-form.module';
import { NgScrollbarModule } from 'ngx-scrollbar';

@NgModule({
  imports: [
    CommonModule,
    GetStartedFormModule,
    NgScrollbarModule
  ],
  exports: [GetStartedFixedComponent],
  declarations: [GetStartedFixedComponent],
})
export class GetStartedFixedModule {}
